import React from 'react'
import { Table, TableHead, TableBody, TableRow, TableCell, IconButton, TextField } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from '@mui/icons-material/Delete';
import { formObjChange } from '../../../../reducers/form';

export default function SetWorkETab({ formName }) {
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  const { eById = {}, eAllIds = [] } = values
  return <div>
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell style={{ width: 10 }} padding='none'>
          </TableCell>
          <TableCell style={{ width: '20%' }}>Раздел</TableCell>
          <TableCell style={{ width: '50%' }}>Работа</TableCell>
          <TableCell style={{ width: '20%' }}>Количество по плану</TableCell>
          <TableCell style={{ width: '20%' }}>Количество по факту</TableCell>
          <TableCell>Ед. изм</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {eAllIds.map(key => {
          return <Row key={key} id={key} obj={eById[key]} formName={formName} />
        })}
        <TableRow style={{ height: 40 * 5 }}>
          <TableCell colSpan={8} />
        </TableRow>
      </TableBody>
    </Table>
  </div>
}

function Row({ id, obj, formName }) {
  const dispatch = useDispatch()
  const deleteRow = () => {
    dispatch(formObjChange(!obj.deleted, { id: id, field: 'eById', fieldObj: 'deleted', name: formName }))
  }
  return (
    <TableRow style={{ background: (obj.deleted) ? '#f3bd48' : undefined }}>
      <TableCell style={{ width: 10 }} padding={'none'}>
        <IconButton aria-label="Delete" onClick={deleteRow} size="large"><DeleteIcon /></IconButton>
      </TableCell>
      <TableCell>{obj.groupName}</TableCell>
      <TableCell>{obj.name}</TableCell>
      <TableCell>{obj.count}</TableCell>
      <TableCell>
        <TextField
          type='number'
          variant="standard"
          onChange={(e) => dispatch(formObjChange(e.target.value, { id: id, field: 'eById', fieldObj: 'countFact', name: formName }))}
          value={obj.countFact || 0}
        />
      </TableCell>
      <TableCell>{obj.storageUnit}</TableCell>
    </TableRow>
  );
}